/**
 * v-trim — Recorta espacios al inicio/final del valor cuando el campo pierde el foco.
 *
 * Uso (no requiere tocar props ni rules del campo):
 *   <v-text-field v-trim v-model="nombre" @input="nombre = nombre.toUpperCase()" />
 *
 * Se escucha 'blur' en FASE DE CAPTURA sobre el elemento raiz del componente
 * (div.v-input): 'blur' no burbujea, pero si se propaga en captura, asi que el
 * handler corre ANTES del onBlur interno de VTextField.
 *
 * Si hay algo que recortar, se escribe el valor recortado en el <input> y se
 * despacha un evento 'input' nativo: VTextField.onInput() lee e.target.value,
 * setea internalValue y emite 'input' -> el v-model del padre queda actualizado.
 * Si no hay nada que recortar no se hace nada (no se emiten eventos ni se revalida).
 *
 * El listener va en el wrapper, no en el <input> interno, para sobrevivir a los
 * re-render de Vuetify sin depender de que el input ya exista.
 *
 * NO usar .trim() dentro de @input: al recortar en cada tecleo el usuario nunca
 * podria escribir un espacio entre palabras.
 */
const HANDLER = "__vTrimHandler__";

function onBlurCapture(event) {
  const target = event.target;
  if (!target) return;

  const tag = target.tagName;
  if (tag !== "INPUT" && tag !== "TEXTAREA") return;

  // No tocar campos de solo lectura / deshabilitados (p.ej. llenados desde un modal).
  if (target.readOnly || target.disabled) return;

  const value = target.value;
  if (typeof value !== "string") return;

  const trimmed = value.trim();
  if (trimmed === value) return; // nada que hacer: salimos sin emitir nada

  target.value = trimmed;
  target.dispatchEvent(new Event("input", { bubbles: true, cancelable: false }));
}

export default {
  inserted(el) {
    if (el[HANDLER]) return; // idempotente
    el[HANDLER] = onBlurCapture;
    el.addEventListener("blur", onBlurCapture, true); // true = captura
  },

  unbind(el) {
    if (!el[HANDLER]) return;
    el.removeEventListener("blur", el[HANDLER], true);
    delete el[HANDLER];
  },
};
